import { useField } from 'formik';
import { FC, useCallback, useState } from 'react';
import { useInterval } from 'react-use';

import { Button } from '@/general/components/Button/Button';

import styles from './ResendCode.module.scss';

interface Props {
  fieldName: string;
  countdownLength: number;
  resendCode: () => Promise<void>;
  isSubmitting: boolean;
}

export const ResendCode: FC<Props> = ({ fieldName, countdownLength, resendCode, isSubmitting }) => {
  const [countdown, setCountdown] = useState<number>(countdownLength);
  const [field, _meta, helpers] = useField<boolean>(fieldName);

  const handleResend = useCallback(async () => {
    helpers.setValue(true);
    helpers.setTouched(true);
    try {
      await resendCode();
      setCountdown(countdownLength);
    } catch (error) {
      // TODO send notification using notistack
    }
    helpers.setValue(false);
  }, [countdownLength, resendCode]);

  useInterval(
    () => {
      setCountdown(countdown - 1);
    },
    countdown > 0 ? 1000 : null,
  );

  return (
    <div className={styles.resendCode}>
      {countdown > 0 ? (
        <div className={styles.resendCodeText}>Code sent. Resend in {countdown} seconds</div>
      ) : (
        <Button
          onClick={handleResend}
          className={styles.resendCodeButton}
          variant="tertiary"
          isLoading={field.value || isSubmitting}
          disabled={field.value || isSubmitting}
          data-testid="resendCodeButton"
          size="small"
        >
          Resend code
        </Button>
      )}
    </div>
  );
};
